import type { InputKind } from '@/lib/api/quality-types.js';

/**
 * The label a human reads for each help-request kind — never the raw wire string.
 *
 * A leaf module on purpose: InputRequiredPanel (value rows) and DeviceTakeoverRow (its own badge)
 * both need this, and putting it in either component's file would make the other import it from a
 * component that also imports it back — the exact cycle DeviceTakeoverRow importing it from
 * InputRequiredPanel.tsx (which mounts DeviceTakeoverRow) created.
 */
export const KIND_LABEL: Record<InputKind, string> = {
  credential: 'Login',
  otp: 'One-time code',
  text: 'Value',
  device_takeover: 'Device',
};
